import { Particle, type ParticleOptions } from "../Particle";
import { MovesLiquid } from "../behaviors/MovesLiquid";
import { HeatTransfer } from "../behaviors/HeatTransfer";
import { adjustColor } from "../../utils/color";

export class Oil extends Particle {
    static baseColor = 0x3E2723; // Dark Brown

    constructor(options: Partial<ParticleOptions> = {}) {
        super({
            name: "Oil",
            color: adjustColor(Oil.baseColor, 10),
            behaviors: [
                new MovesLiquid(0.6), // 粘度 0.6，比较粘稠
                new HeatTransfer(0.05) // 导热性较差
            ],
            props: { 
                isLiquid: true,
                isFlammable: true, // 可燃
                density: 0.8 // 密度 0.8 < 1 (水的密度)，会浮在水上
            },
            temperature: 20,
            minTemp: -50,
            maxTemp: 300,
            ...options
        });
    }
}
